var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-sidebar',{attrs:{"active":_vm.$store.state.sidebars.showPersonalDocumentsCreateForm,"icon":_vm.sidebar.icon,"title":_vm.sidebar.title}},[(_vm.$store.state.views.personal_document_categories.length && _vm.$store.state.sidebars.showPersonalDocumentsCreateForm)?_c('personal-documents-create-form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }